import Select from '@admin/components/form/select'
import PropTypes from 'prop-types'
import React from 'react'

const CheckboxGroup = React.forwardRef((props, ref) => {
  return <Select { ...props } ref={ ref } multiple={ true } />
})

CheckboxGroup.propTypes = {
  selectFirst: PropTypes.bool
}

export default CheckboxGroup